// extracted by mini-css-extract-plugin
module.exports = {"NavElement":"NavElement_NavElement__3WVaY","Disabled":"NavElement_Disabled__1TS_-"};